import { FC, useState } from 'react'
import { CancelMembership } from './cancel-membership/CancelMembership'
import { ChangeMemberShip } from './change-membership/ChangeMembership'

interface Props {
  closeDialog: () => void
  openAddUsersDialog: () => void
}
export const ChangePlan: FC<Props> = (props) => {
  const [isCancelViewShown, setIsCancelViewShown] = useState<boolean>(false)
  const handleCancelClick = () => {
    setIsCancelViewShown(true)
  }
  return (
    <>
      {isCancelViewShown ? (
        <CancelMembership {...props} />
      ) : (
        <ChangeMemberShip {...props} handleCancelClick={handleCancelClick} />
      )}
    </>
  )
}
